import React from 'react';
import { forceToArray } from '../../utils/Helper';

import './VideoCards.scss';

const VideoCards = (props) => {
  const headline = props.title || '';
  const { videos } = props;
  const { url } = props;

  const videoLink = (id) => {
    return `https://www.youtube.com/embed/${id}`;
  };

  const moreButton = (
    <div className="col-12 child-more-item">
      <div className="item-more">
        <a target="_blank" className="button button--ghost-white" href={url}>
          <span>Continua</span>
        </a>
      </div>
    </div>
  );

  const videoEle = (videos) => {
    return (
      <>
        {videos &&
          videos.map((v, k) => {
            return (
              <div className="col-12 col-lg-6" key={k}>
                <iframe
                  width="560"
                  height="315"
                  src={videoLink(v.id)}
                  frameBorder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen=""
                />
                <div className="content">
                  {v.title && <div className="title">{v.title}</div>}
                  {v.desc && <div className="desc">{v.desc}</div>}
                </div>
              </div>
            );
          })}
      </>
    );
  };

  const headlineEle = (
    <>
      {headline && (
        <div className="col-12">
          <h5>{headline}</h5>
        </div>
      )}
    </>
  );

  return (
    <>
      <section className="container section-mainPage-videoCards">
        <div className="row">
          {headlineEle}
          {videoEle(forceToArray(videos))}
          {moreButton}
        </div>
      </section>
    </>
  );
};

export default VideoCards;
